/**
 * Popular Lucide Icons (using naming convention from lucide-vue-next)
 */
export const LUCIDE_ICONS = [
  // Fantasy/RPG themed
  'sword',
  'swords',
  'shield',
  'shield-check',
  'crown',
  'gem',
  'scroll',
  'wand',
  'wand-2',
  'flame',
  'zap',
  'snowflake',
  'droplet',
  'wind',
  'skull',
  'ghost',
  'bug',
  'bird',
  'cat',
  'dog',
  'fish',
  'rabbit',
  // People
  'user',
  'users',
  'user-circle',
  'user-check',
  'user-plus',
  'user-x',
  'person-standing',
  'baby',
  'accessibility',
  // Documents
  'file',
  'file-text',
  'file-plus',
  'files',
  'notebook',
  'book',
  'book-open',
  'book-marked',
  'library',
  'scroll-text',
  'clipboard',
  'clipboard-list',
  // Folders
  'folder',
  'folder-open',
  'folder-plus',
  'folder-minus',
  'folder-check',
  'folder-heart',
  'folder-key',
  'folder-lock',
  'folder-search',
  'folders',
  // Locations
  'map',
  'map-pin',
  'compass',
  'navigation',
  'globe',
  'globe-2',
  'home',
  'building',
  'building-2',
  'castle',
  'church',
  'tent',
  'warehouse',
  'mountain',
  'mountain-snow',
  'trees',
  'tree-pine',
  'palmtree',
  // Items
  'backpack',
  'briefcase',
  'box',
  'package',
  'archive',
  'key',
  'lock',
  'unlock',
  'coins',
  'wallet',
  'gift',
  'trophy',
  'medal',
  'award',
  'hammer',
  'wrench',
  'axe',
  'pickaxe',
  'shovel',
  // Actions
  'target',
  'crosshair',
  'eye',
  'eye-off',
  'search',
  'zoom-in',
  'hand',
  'grab',
  'pointer',
  'move',
  'rotate-cw',
  // Time
  'clock',
  'timer',
  'hourglass',
  'calendar',
  'calendar-days',
  'sun',
  'moon',
  'sunrise',
  'sunset',
  'cloud',
  'cloud-rain',
  'cloud-snow',
  'cloud-lightning',
  // Communication
  'message-circle',
  'message-square',
  'mail',
  'send',
  'megaphone',
  'bell',
  // Status
  'heart',
  'heart-pulse',
  'activity',
  'thermometer',
  'pill',
  'syringe',
  'star',
  'sparkles',
  'sparkle',
  'circle',
  'square',
  'triangle',
  'check',
  'x',
  'alert-circle',
  'alert-triangle',
  'info',
  'help-circle',
  // Misc
  'dice-1',
  'dice-2',
  'dice-3',
  'dice-4',
  'dice-5',
  'dice-6',
  'gamepad',
  'gamepad-2',
  'music',
  'volume-2',
  'image',
  'camera'
]

export default LUCIDE_ICONS
